module.exports = __webpack_public_path__ + "img/ico_vod_age_15.5ef2db0f.png";